import { useState } from "react";
import { useModalStore } from "@store/modal/modal";
import {
  fetchCustomTransactionCategoryQuery,
  useGetExpensePlanCategoriesQuery,
} from "@services/budget/queries";
import { RemoveBudgetTransactionCategoryModal } from "./RemoveBudgetTransactionCategoryModal";
import { RemoveBudgetTransactionCategoryWithExpensePlanModal } from "./RemoveBudgetTransactionCategoryWithExpensePlanModal";
import { RemoveBudgetTransactionCategoryWithTransactionsModal } from "./RemoveBudgetTransactionCategoryWithTransactionsModal";

export const useRemoveBudgetTransactionCategoryModal = () => {
  const { create } = useModalStore();

  const [isLoading, setIsLoading] = useState(false);

  const { data: transactionCategories } = useGetExpensePlanCategoriesQuery();

  const openRemoveCategoryModal = async (transactionCategoryId: number) => {
    if (!transactionCategories) {
      return;
    }

    setIsLoading(true);

    const data = await fetchCustomTransactionCategoryQuery({
      transactionCategoryId,
    });

    // Case: category has no expense plans and no transactions
    if (!data.hasExpensePlans && !data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryModal
          {...modalProps}
          transactionCategoryData={data}
        />
      ));
    }

    // Case: category has expense plans and no transactions
    if (data.hasExpensePlans && !data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithExpensePlanModal
          {...modalProps}
          transactionCategoryData={data}
        />
      ));
    }

    // Case: category has transactions assignes but no expense plans
    if (!data.hasExpensePlans && data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithTransactionsModal
          {...modalProps}
          transactionCategoryData={data}
          transactionCategories={transactionCategories}
        />
      ));
    }

    // Case: category has both expense plans and transactions
    if (data.hasExpensePlans && data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithExpensePlanModal
          {...modalProps}
          transactionCategoryData={data}
          onSubmit={() => {
            create((modalProps) => (
              <RemoveBudgetTransactionCategoryWithTransactionsModal
                {...modalProps}
                transactionCategoryData={data}
                transactionCategories={transactionCategories}
              />
            ));
          }}
        />
      ));
    }

    setIsLoading(false);
  };

  return {
    openRemoveCategoryModal,
    isLoading,
  };
};
